module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"first_step":"Starting brugerstyring.dk","fetching_user":"Logging in and preparing your profile"},"da":{"first_step":"Starter brugerstyring.dk","fetching_user":"Logger dig ind, og henter din profil"}}')
  delete Component.options._Ctor
}
